export const RESOURCE_BLOCKS = [
  "Upcoming Events",
  "Phil Blog",
  "Case Study",
  "White Paper",
];

export const POSTS_PER_SECTION = 5; // 5 posts per section is the limit in resources page.
